import { SubmissionTypeEnum } from '../users/enum/submission-type-enum';
import { Deserializable } from '../protocols/deserializable';
import { SubmissionStatusIdEnum } from '../enum/shared/submission-status-id.enum';

export class MemberFundingBlockingSubmission implements Deserializable {
  public id!: number;
  public typeId!: SubmissionTypeEnum;
  public typeName!: string;
  public ownerId!: number;
  public statusId!: SubmissionStatusIdEnum;

  public onDeserialize(): void {}
}
